import { Provider } from '@angular/core';

import { FreshDataProvider } from '@frontend/sports/data-refresh/feature';

import { LayoutRefreshProvider } from './layout-refresh.provider';

export const provideLayout = (): Provider[] => {
    return [{ provide: FreshDataProvider, useClass: LayoutRefreshProvider, multi: true }];
};
